/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import * as Scroll from "react-scroll";
import parse from "html-react-parser";
import { Switch, Route, useRouteMatch, useLocation } from "react-router-dom";
import { Typography, IconButton } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { getContent } from "../../services";
import { CardBerita } from "../../components";
import { usePagination } from "../../hooks";

const scroll = Scroll.animateScroll;

const StyledWrapBerita = styled.div`
  margin-bottom: 4rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 3rem;
  row-gap: 4rem;
  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 750px) {
    grid-template-columns: 1fr;
  }
`;

const DetailBerita = ({ isId, data }: any) => {
  const { title_id, title_en, content_id, content_en, image } = data;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        style={{ marginBottom: "2rem" }}
        gutterBottom
      >
        {isId ? title_id : title_en}
      </Typography>
      {image ? (
        <img
          src={`${process.env.REACT_APP_URL}/images/${image}`}
          width="100%"
          alt={title_id}
        />
      ) : (
        <div
          style={{
            backgroundColor: "#c1c1c1",
            width: "100%",
            height: 300,
          }}
        />
      )}

      <div id="content" style={{ margin: "2rem 0" }}>
        {parse(isId ? content_id : content_en)}
      </div>
    </>
  );
};

const Berita = ({ isId }: any) => {
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const [beritaState, setBeritaState] = useState([]);
  const [pageHook, setPageHook] = usePagination({
    page: 1,
    limit: 9,
    total: 0,
  });
  const [loadingState, setLoadingState] = useState(false);
  const [arrPageState, setArrPageState] = useState<any>([]);
  const { page, limit, total } = pageHook;
  const lastPage = Math.ceil(total / limit);

  const fetchBerita = async () => {
    setLoadingState(true);
    try {
      const res = await getContent(4, limit, page);
      setBeritaState(res.data.rows);
      setPageHook({ ...pageHook, total: res.data.total });
      const limitPage = Math.ceil(res.data.total / limit);
      if (limitPage === 1) setArrPageState([1]);
      if (limitPage === 2) setArrPageState([1, 2]);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchBerita();
  }, [page]);

  return (
    <Switch>
      <Route exact path={path}>
        <Typography
          variant="h4"
          color="primary"
          style={{ marginBottom: "2rem" }}
          gutterBottom
        >
          {isId ? "Berita" : "News"}
        </Typography>
        <StyledWrapBerita>
          {loadingState ? (
            [1, 2, 3].map(() => (
              <div>
                <Skeleton
                  variant="rect"
                  height={200}
                  style={{ marginBottom: 8 }}
                />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            ))
          ) : beritaState.length === 0 ? (
            <Typography color="textPrimary">
              {isId ? "Tidak ada data berita" : "No news data"}
            </Typography>
          ) : (
            beritaState.map((r: any) => (
              <CardBerita
                key={r.title_id}
                url={url + "/" + r.title_id}
                data={r}
              />
            ))
            // [1, 2, 3, 4, 5, 6, 7, 8, 9].map((r: any) => (
            //   <CardBerita
            //     key={r}
            //     url={url + "/" + dummyData.title_id}
            //     data={dummyData}
            //   />
            // ))
          )}
        </StyledWrapBerita>
        {loadingState ? (
          <Skeleton />
        ) : (
          <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
            <IconButton
              aria-label="back"
              size="small"
              disabled={page === 1}
              onClick={() => {
                setPageHook({ ...pageHook, page: page - 1 });
                if (page === 3) {
                  setArrPageState([1, 2, 3]);
                } else if (page % 3 === 0) {
                  setArrPageState([page - 3, page - 2, page - 1]);
                }
              }}
            >
              <ChevronLeft fontSize="inherit" />
            </IconButton>
            {arrPageState.map((numberPage: number) => (
              <Typography
                style={{
                  cursor: "pointer",
                  fontWeight: page === numberPage ? 700 : 500,
                }}
                color={page === numberPage ? "primary" : "textPrimary"}
                onClick={() => setPageHook({ ...pageHook, page: numberPage })}
              >
                {numberPage}
              </Typography>
            ))}
            <IconButton
              aria-label="next"
              size="small"
              disabled={lastPage <= page}
              onClick={() => {
                if (lastPage >= page + 1) {
                  setPageHook({ ...pageHook, page: page + 1 });
                  if (lastPage > page + 3) {
                    if ((page + 1) % 3 === 0) {
                      setArrPageState([page + 1, page + 2, page + 3]);
                    }
                  }
                }
              }}
            >
              <ChevronRight fontSize="inherit" />
            </IconButton>
          </div>
        )}
      </Route>
      <Route path={`${path}/:beritaId`}>
        <DetailBerita data={location.state} isId={isId} />
      </Route>
    </Switch>
  );
};

export default Berita;
